package com.xtream.data_kmp.db.dao

import androidx.paging.PagingSource
import androidx.room3.EntityDeleteOrUpdateAdapter
import androidx.room3.EntityInsertAdapter
import androidx.room3.RoomDatabase
import androidx.room3.RoomRawQuery
import androidx.room3.coroutines.createFlow
import androidx.room3.paging.PagingSourceDaoReturnTypeConverter
import androidx.room3.util.appendPlaceholders
import androidx.room3.util.getColumnIndex
import androidx.room3.util.getColumnIndexOrThrow
import androidx.room3.util.performSuspending
import androidx.sqlite.SQLiteStatement
import com.xtream.data_kmp.WatchedIntermediateVodStream
import com.xtream.data_kmp.WatchedVodStreams
import com.xtream.data_kmp.dto.TrendingMovie
import com.xtream.data_kmp.dto.VodStream
import kotlin.Boolean
import kotlin.Double
import kotlin.Float
import kotlin.Int
import kotlin.Long
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlin.collections.List
import kotlin.collections.MutableList
import kotlin.collections.mutableListOf
import kotlin.reflect.KClass
import kotlin.text.StringBuilder
import kotlinx.coroutines.flow.Flow

@Suppress(names = ["UNCHECKED_CAST", "DEPRECATION", "REDUNDANT_PROJECTION", "REMOVAL", "MemberExtensionConflict"])
internal class VodStreamsDao_Impl(
  __db: RoomDatabase,
) : VodStreamsDao() {
  private val __db: RoomDatabase

  private val __insertAdapterOfVodStream: EntityInsertAdapter<VodStream>

  private val __insertAdapterOfTrendingMovie: EntityInsertAdapter<TrendingMovie>

  private val __deleteAdapterOfVodStream: EntityDeleteOrUpdateAdapter<VodStream>

  private val __pagingSourceDaoReturnTypeConverter: PagingSourceDaoReturnTypeConverter =
      PagingSourceDaoReturnTypeConverter()
  init {
    this.__db = __db
    this.__insertAdapterOfVodStream = object : EntityInsertAdapter<VodStream>() {
      protected override fun createQuery(): String = "INSERT OR REPLACE INTO `vodTable` (`added`,`categoryId`,`customSid`,`directSource`,`isAdult`,`name`,`num`,`streamIcon`,`streamId`,`streamType`,`containerExtension`,`rating`,`ratingFiveBased`) VALUES (?,?,?,?,?,?,?,?,?,?,?,?,?)"

      protected override fun bind(statement: SQLiteStatement, entity: VodStream) {
        statement.bindText(1, entity.added)
        statement.bindLong(2, entity.categoryId.toLong())
        val _tmpCustomSid: String? = entity.customSid
        if (_tmpCustomSid == null) {
          statement.bindNull(3)
        } else {
          statement.bindText(3, _tmpCustomSid)
        }
        val _tmpDirectSource: String? = entity.directSource
        if (_tmpDirectSource == null) {
          statement.bindNull(4)
        } else {
          statement.bindText(4, _tmpDirectSource)
        }
        statement.bindLong(5, entity.isAdult.toLong())
        statement.bindText(6, entity.name)
        val _tmpNum: Int? = entity.num
        if (_tmpNum == null) {
          statement.bindNull(7)
        } else {
          statement.bindLong(7, _tmpNum.toLong())
        }
        val _tmpStreamIcon: String? = entity.streamIcon
        if (_tmpStreamIcon == null) {
          statement.bindNull(8)
        } else {
          statement.bindText(8, _tmpStreamIcon)
        }
        statement.bindLong(9, entity.streamId.toLong())
        statement.bindText(10, entity.streamType)
        statement.bindText(11, entity.containerExtension)
        val _tmpRating: String? = entity.rating
        if (_tmpRating == null) {
          statement.bindNull(12)
        } else {
          statement.bindText(12, _tmpRating)
        }
        val _tmpRatingFiveBased: String? = entity.ratingFiveBased
        if (_tmpRatingFiveBased == null) {
          statement.bindNull(13)
        } else {
          statement.bindText(13, _tmpRatingFiveBased)
        }
      }
    }
    this.__insertAdapterOfTrendingMovie = object : EntityInsertAdapter<TrendingMovie>() {
      protected override fun createQuery(): String = "INSERT OR REPLACE INTO `TrendingMovies` (`adult`,`backdrop`,`id`,`name`,`overview`,`streamIcon`,`popularity`,`releaseDate`,`voteAverage`,`streamId`) VALUES (?,?,?,?,?,?,?,?,?,?)"

      protected override fun bind(statement: SQLiteStatement, entity: TrendingMovie) {
        val _tmp: Int = if (entity.adult) 1 else 0
        statement.bindLong(1, _tmp.toLong())
        val _tmpBackdrop: String? = entity.backdrop
        if (_tmpBackdrop == null) {
          statement.bindNull(2)
        } else {
          statement.bindText(2, _tmpBackdrop)
        }
        statement.bindLong(3, entity.id.toLong())
        statement.bindText(4, entity.name)
        statement.bindText(5, entity.overview)
        val _tmpStreamIcon: String? = entity.streamIcon
        if (_tmpStreamIcon == null) {
          statement.bindNull(6)
        } else {
          statement.bindText(6, _tmpStreamIcon)
        }
        val _tmpPopularity: Float? = entity.popularity
        if (_tmpPopularity == null) {
          statement.bindNull(7)
        } else {
          statement.bindDouble(7, _tmpPopularity.toDouble())
        }
        statement.bindText(8, entity.releaseDate)
        val _tmpVoteAverage: Double? = entity.voteAverage
        if (_tmpVoteAverage == null) {
          statement.bindNull(9)
        } else {
          statement.bindDouble(9, _tmpVoteAverage)
        }
        statement.bindLong(10, entity.streamId.toLong())
      }
    }
    this.__deleteAdapterOfVodStream = object : EntityDeleteOrUpdateAdapter<VodStream>() {
      protected override fun createQuery(): String = "DELETE FROM `vodTable` WHERE `streamId` = ?"

      protected override fun bind(statement: SQLiteStatement, entity: VodStream) {
        statement.bindLong(1, entity.streamId.toLong())
      }
    }
  }

  public override suspend fun insert(item: VodStream): Unit = performSuspending(__db, false, true) { _connection ->
    __insertAdapterOfVodStream.insert(_connection, item)
  }

  public override suspend fun insert(items: List<VodStream>): Unit = performSuspending(__db, false, true) { _connection ->
    __insertAdapterOfVodStream.insert(_connection, items)
  }

  public override suspend fun insertTrending(newList: List<TrendingMovie>): Unit = performSuspending(__db, false, true) { _connection ->
    __insertAdapterOfTrendingMovie.insert(_connection, newList)
  }

  public override suspend fun delete(item: VodStream): Unit = performSuspending(__db, false, true) { _connection ->
    __deleteAdapterOfVodStream.handle(_connection, item)
  }

  public override suspend fun delete(items: List<VodStream>): Unit = performSuspending(__db, false, true) { _connection ->
    __deleteAdapterOfVodStream.handleMultiple(_connection, items)
  }

  public override fun allAsFlow(): Flow<List<VodStream>> {
    val _sql: String = "SELECT * FROM vodTable ORDER BY added DESC"
    return createFlow(__db, false, arrayOf("vodTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _columnIndexOfAdded: Int = getColumnIndexOrThrow(_stmt, "added")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfCustomSid: Int = getColumnIndexOrThrow(_stmt, "customSid")
        val _columnIndexOfDirectSource: Int = getColumnIndexOrThrow(_stmt, "directSource")
        val _columnIndexOfIsAdult: Int = getColumnIndexOrThrow(_stmt, "isAdult")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _columnIndexOfContainerExtension: Int = getColumnIndexOrThrow(_stmt, "containerExtension")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _result: MutableList<VodStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: VodStream
          val _tmpAdded: String
          _tmpAdded = _stmt.getText(_columnIndexOfAdded)
          val _tmpCategoryId: Int
          _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          val _tmpCustomSid: String?
          if (_stmt.isNull(_columnIndexOfCustomSid)) {
            _tmpCustomSid = null
          } else {
            _tmpCustomSid = _stmt.getText(_columnIndexOfCustomSid)
          }
          val _tmpDirectSource: String?
          if (_stmt.isNull(_columnIndexOfDirectSource)) {
            _tmpDirectSource = null
          } else {
            _tmpDirectSource = _stmt.getText(_columnIndexOfDirectSource)
          }
          val _tmpIsAdult: Int
          _tmpIsAdult = _stmt.getLong(_columnIndexOfIsAdult).toInt()
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          val _tmpContainerExtension: String
          _tmpContainerExtension = _stmt.getText(_columnIndexOfContainerExtension)
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          _item = VodStream(_tmpAdded,_tmpCategoryId,_tmpCustomSid,_tmpDirectSource,_tmpIsAdult,_tmpName,_tmpNum,_tmpStreamIcon,_tmpStreamId,_tmpStreamType,_tmpContainerExtension,_tmpRating,_tmpRatingFiveBased)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun allAsFlow(
    categoryId: Int?,
    nameQuery: String?,
    limit: Int?,
    offset: Int?,
  ): Flow<List<VodStream>> {
    val _sql: String = "SELECT * FROM vodTable WHERE (? IS NULL OR categoryId = ?) AND (? IS NULL OR name LIKE '%' || ? || '%')  ORDER BY added DESC LIMIT ? OFFSET ?"
    return createFlow(__db, false, arrayOf("vodTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (categoryId == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, categoryId.toLong())
        }
        _argIndex = 2
        if (categoryId == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, categoryId.toLong())
        }
        _argIndex = 3
        if (nameQuery == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindText(_argIndex, nameQuery)
        }
        _argIndex = 4
        if (nameQuery == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindText(_argIndex, nameQuery)
        }
        _argIndex = 5
        if (limit == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, limit.toLong())
        }
        _argIndex = 6
        if (offset == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, offset.toLong())
        }
        val _columnIndexOfAdded: Int = getColumnIndexOrThrow(_stmt, "added")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfCustomSid: Int = getColumnIndexOrThrow(_stmt, "customSid")
        val _columnIndexOfDirectSource: Int = getColumnIndexOrThrow(_stmt, "directSource")
        val _columnIndexOfIsAdult: Int = getColumnIndexOrThrow(_stmt, "isAdult")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _columnIndexOfContainerExtension: Int = getColumnIndexOrThrow(_stmt, "containerExtension")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _result: MutableList<VodStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: VodStream
          val _tmpAdded: String
          _tmpAdded = _stmt.getText(_columnIndexOfAdded)
          val _tmpCategoryId: Int
          _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          val _tmpCustomSid: String?
          if (_stmt.isNull(_columnIndexOfCustomSid)) {
            _tmpCustomSid = null
          } else {
            _tmpCustomSid = _stmt.getText(_columnIndexOfCustomSid)
          }
          val _tmpDirectSource: String?
          if (_stmt.isNull(_columnIndexOfDirectSource)) {
            _tmpDirectSource = null
          } else {
            _tmpDirectSource = _stmt.getText(_columnIndexOfDirectSource)
          }
          val _tmpIsAdult: Int
          _tmpIsAdult = _stmt.getLong(_columnIndexOfIsAdult).toInt()
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          val _tmpContainerExtension: String
          _tmpContainerExtension = _stmt.getText(_columnIndexOfContainerExtension)
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          _item = VodStream(_tmpAdded,_tmpCategoryId,_tmpCustomSid,_tmpDirectSource,_tmpIsAdult,_tmpName,_tmpNum,_tmpStreamIcon,_tmpStreamId,_tmpStreamType,_tmpContainerExtension,_tmpRating,_tmpRatingFiveBased)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun allAsFlow(categoryId: Int?, nameQuery: String?): Flow<List<VodStream>> {
    val _sql: String = """
        |SELECT * FROM vodTable 
        |            WHERE (? IS NULL OR categoryId = ?)
        |             AND (? IS NULL OR name LIKE '%' || ? || '%') 
        |             ORDER BY added DESC
        """.trimMargin()
    return createFlow(__db, false, arrayOf("vodTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (categoryId == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, categoryId.toLong())
        }
        _argIndex = 2
        if (categoryId == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, categoryId.toLong())
        }
        _argIndex = 3
        if (nameQuery == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindText(_argIndex, nameQuery)
        }
        _argIndex = 4
        if (nameQuery == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindText(_argIndex, nameQuery)
        }
        val _columnIndexOfAdded: Int = getColumnIndexOrThrow(_stmt, "added")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfCustomSid: Int = getColumnIndexOrThrow(_stmt, "customSid")
        val _columnIndexOfDirectSource: Int = getColumnIndexOrThrow(_stmt, "directSource")
        val _columnIndexOfIsAdult: Int = getColumnIndexOrThrow(_stmt, "isAdult")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _columnIndexOfContainerExtension: Int = getColumnIndexOrThrow(_stmt, "containerExtension")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _result: MutableList<VodStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: VodStream
          val _tmpAdded: String
          _tmpAdded = _stmt.getText(_columnIndexOfAdded)
          val _tmpCategoryId: Int
          _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          val _tmpCustomSid: String?
          if (_stmt.isNull(_columnIndexOfCustomSid)) {
            _tmpCustomSid = null
          } else {
            _tmpCustomSid = _stmt.getText(_columnIndexOfCustomSid)
          }
          val _tmpDirectSource: String?
          if (_stmt.isNull(_columnIndexOfDirectSource)) {
            _tmpDirectSource = null
          } else {
            _tmpDirectSource = _stmt.getText(_columnIndexOfDirectSource)
          }
          val _tmpIsAdult: Int
          _tmpIsAdult = _stmt.getLong(_columnIndexOfIsAdult).toInt()
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          val _tmpContainerExtension: String
          _tmpContainerExtension = _stmt.getText(_columnIndexOfContainerExtension)
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          _item = VodStream(_tmpAdded,_tmpCategoryId,_tmpCustomSid,_tmpDirectSource,_tmpIsAdult,_tmpName,_tmpNum,_tmpStreamIcon,_tmpStreamId,_tmpStreamType,_tmpContainerExtension,_tmpRating,_tmpRatingFiveBased)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun allAsPagingSource(categoryId: Int?, nameQuery: String?): PagingSource<Int, VodStream> {
    val _sql: String = "SELECT * FROM vodTable WHERE (? IS NULL OR categoryId = ?) AND (? IS NULL OR name LIKE '%' || ? || '%')  ORDER BY added DESC"
    val _rawQuery: RoomRawQuery = RoomRawQuery(_sql) { _stmt ->
      var _argIndex: Int = 1
      if (categoryId == null) {
        _stmt.bindNull(_argIndex)
      } else {
        _stmt.bindLong(_argIndex, categoryId.toLong())
      }
      _argIndex = 2
      if (categoryId == null) {
        _stmt.bindNull(_argIndex)
      } else {
        _stmt.bindLong(_argIndex, categoryId.toLong())
      }
      _argIndex = 3
      if (nameQuery == null) {
        _stmt.bindNull(_argIndex)
      } else {
        _stmt.bindText(_argIndex, nameQuery)
      }
      _argIndex = 4
      if (nameQuery == null) {
        _stmt.bindNull(_argIndex)
      } else {
        _stmt.bindText(_argIndex, nameQuery)
      }
    }
    return __pagingSourceDaoReturnTypeConverter.convert(__db, arrayOf("vodTable"), _rawQuery) { _converterQuery ->
      performSuspending<MutableList<VodStream>>(__db, true, false) { _connection ->
        val _stmt: SQLiteStatement = _connection.prepare(_converterQuery.sql)
        try {
          _converterQuery.getBindingFunction().invoke(_stmt)
          val _columnIndexOfAdded: Int = getColumnIndexOrThrow(_stmt, "added")
          val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
          val _columnIndexOfCustomSid: Int = getColumnIndexOrThrow(_stmt, "customSid")
          val _columnIndexOfDirectSource: Int = getColumnIndexOrThrow(_stmt, "directSource")
          val _columnIndexOfIsAdult: Int = getColumnIndexOrThrow(_stmt, "isAdult")
          val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
          val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
          val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
          val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
          val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
          val _columnIndexOfContainerExtension: Int = getColumnIndexOrThrow(_stmt, "containerExtension")
          val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
          val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
          val _result: MutableList<VodStream> = mutableListOf()
          while (_stmt.step()) {
            val _item: VodStream
            val _tmpAdded: String
            _tmpAdded = _stmt.getText(_columnIndexOfAdded)
            val _tmpCategoryId: Int
            _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
            val _tmpCustomSid: String?
            if (_stmt.isNull(_columnIndexOfCustomSid)) {
              _tmpCustomSid = null
            } else {
              _tmpCustomSid = _stmt.getText(_columnIndexOfCustomSid)
            }
            val _tmpDirectSource: String?
            if (_stmt.isNull(_columnIndexOfDirectSource)) {
              _tmpDirectSource = null
            } else {
              _tmpDirectSource = _stmt.getText(_columnIndexOfDirectSource)
            }
            val _tmpIsAdult: Int
            _tmpIsAdult = _stmt.getLong(_columnIndexOfIsAdult).toInt()
            val _tmpName: String
            _tmpName = _stmt.getText(_columnIndexOfName)
            val _tmpNum: Int?
            if (_stmt.isNull(_columnIndexOfNum)) {
              _tmpNum = null
            } else {
              _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
            }
            val _tmpStreamIcon: String?
            if (_stmt.isNull(_columnIndexOfStreamIcon)) {
              _tmpStreamIcon = null
            } else {
              _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
            }
            val _tmpStreamId: Int
            _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
            val _tmpStreamType: String
            _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
            val _tmpContainerExtension: String
            _tmpContainerExtension = _stmt.getText(_columnIndexOfContainerExtension)
            val _tmpRating: String?
            if (_stmt.isNull(_columnIndexOfRating)) {
              _tmpRating = null
            } else {
              _tmpRating = _stmt.getText(_columnIndexOfRating)
            }
            val _tmpRatingFiveBased: String?
            if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
              _tmpRatingFiveBased = null
            } else {
              _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
            }
            _item = VodStream(_tmpAdded,_tmpCategoryId,_tmpCustomSid,_tmpDirectSource,_tmpIsAdult,_tmpName,_tmpNum,_tmpStreamIcon,_tmpStreamId,_tmpStreamType,_tmpContainerExtension,_tmpRating,_tmpRatingFiveBased)
            _result.add(_item)
          }
          _result
        } finally {
          _stmt.close()
        }
      }
    }
  }

  public override fun allAsPagingSource(categoryIds: List<Int>?, nameQuery: String?): PagingSource<Int, VodStream> {
    val _stringBuilder: StringBuilder = StringBuilder()
    _stringBuilder.append("SELECT * FROM vodTable WHERE (")
    val _inputSize: Int = if (categoryIds == null) 1 else categoryIds.size
    appendPlaceholders(_stringBuilder, _inputSize)
    _stringBuilder.append(" IS NULL OR categoryId IN (")
    val _inputSize_1: Int = if (categoryIds == null) 1 else categoryIds.size
    appendPlaceholders(_stringBuilder, _inputSize_1)
    _stringBuilder.append(")) AND (")
    _stringBuilder.append("?")
    _stringBuilder.append(" IS NULL OR name LIKE '%' || ")
    _stringBuilder.append("?")
    _stringBuilder.append(" || '%')  ORDER BY added DESC")
    val _sql: String = _stringBuilder.toString()
    val _rawQuery: RoomRawQuery = RoomRawQuery(_sql) { _stmt ->
      var _argIndex: Int = 1
      if (categoryIds == null) {
        _stmt.bindNull(_argIndex)
      } else {
        for (_item: Int in categoryIds) {
          _stmt.bindLong(_argIndex, _item.toLong())
          _argIndex++
        }
      }
      _argIndex = 1 + _inputSize
      if (categoryIds == null) {
        _stmt.bindNull(_argIndex)
      } else {
        for (_item_1: Int in categoryIds) {
          _stmt.bindLong(_argIndex, _item_1.toLong())
          _argIndex++
        }
      }
      _argIndex = 1 + _inputSize + _inputSize
      if (nameQuery == null) {
        _stmt.bindNull(_argIndex)
      } else {
        _stmt.bindText(_argIndex, nameQuery)
      }
      _argIndex = 2 + _inputSize + _inputSize
      if (nameQuery == null) {
        _stmt.bindNull(_argIndex)
      } else {
        _stmt.bindText(_argIndex, nameQuery)
      }
    }
    return __pagingSourceDaoReturnTypeConverter.convert(__db, arrayOf("vodTable"), _rawQuery) { _converterQuery ->
      performSuspending<MutableList<VodStream>>(__db, true, false) { _connection ->
        val _stmt: SQLiteStatement = _connection.prepare(_converterQuery.sql)
        try {
          _converterQuery.getBindingFunction().invoke(_stmt)
          val _columnIndexOfAdded: Int = getColumnIndexOrThrow(_stmt, "added")
          val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
          val _columnIndexOfCustomSid: Int = getColumnIndexOrThrow(_stmt, "customSid")
          val _columnIndexOfDirectSource: Int = getColumnIndexOrThrow(_stmt, "directSource")
          val _columnIndexOfIsAdult: Int = getColumnIndexOrThrow(_stmt, "isAdult")
          val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
          val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
          val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
          val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
          val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
          val _columnIndexOfContainerExtension: Int = getColumnIndexOrThrow(_stmt, "containerExtension")
          val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
          val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
          val _result: MutableList<VodStream> = mutableListOf()
          while (_stmt.step()) {
            val _item: VodStream
            val _tmpAdded: String
            _tmpAdded = _stmt.getText(_columnIndexOfAdded)
            val _tmpCategoryId: Int
            _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
            val _tmpCustomSid: String?
            if (_stmt.isNull(_columnIndexOfCustomSid)) {
              _tmpCustomSid = null
            } else {
              _tmpCustomSid = _stmt.getText(_columnIndexOfCustomSid)
            }
            val _tmpDirectSource: String?
            if (_stmt.isNull(_columnIndexOfDirectSource)) {
              _tmpDirectSource = null
            } else {
              _tmpDirectSource = _stmt.getText(_columnIndexOfDirectSource)
            }
            val _tmpIsAdult: Int
            _tmpIsAdult = _stmt.getLong(_columnIndexOfIsAdult).toInt()
            val _tmpName: String
            _tmpName = _stmt.getText(_columnIndexOfName)
            val _tmpNum: Int?
            if (_stmt.isNull(_columnIndexOfNum)) {
              _tmpNum = null
            } else {
              _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
            }
            val _tmpStreamIcon: String?
            if (_stmt.isNull(_columnIndexOfStreamIcon)) {
              _tmpStreamIcon = null
            } else {
              _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
            }
            val _tmpStreamId: Int
            _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
            val _tmpStreamType: String
            _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
            val _tmpContainerExtension: String
            _tmpContainerExtension = _stmt.getText(_columnIndexOfContainerExtension)
            val _tmpRating: String?
            if (_stmt.isNull(_columnIndexOfRating)) {
              _tmpRating = null
            } else {
              _tmpRating = _stmt.getText(_columnIndexOfRating)
            }
            val _tmpRatingFiveBased: String?
            if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
              _tmpRatingFiveBased = null
            } else {
              _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
            }
            _item = VodStream(_tmpAdded,_tmpCategoryId,_tmpCustomSid,_tmpDirectSource,_tmpIsAdult,_tmpName,_tmpNum,_tmpStreamIcon,_tmpStreamId,_tmpStreamType,_tmpContainerExtension,_tmpRating,_tmpRatingFiveBased)
            _result.add(_item)
          }
          _result
        } finally {
          _stmt.close()
        }
      }
    }
  }

  public override fun allAsPagingSource(): PagingSource<Int, VodStream> {
    val _sql: String = "SELECT * FROM vodTable  ORDER BY added DESC"
    val _rawQuery: RoomRawQuery = RoomRawQuery(_sql)
    return __pagingSourceDaoReturnTypeConverter.convert(__db, arrayOf("vodTable"), _rawQuery) { _converterQuery ->
      performSuspending<MutableList<VodStream>>(__db, true, false) { _connection ->
        val _stmt: SQLiteStatement = _connection.prepare(_converterQuery.sql)
        try {
          _converterQuery.getBindingFunction().invoke(_stmt)
          val _columnIndexOfAdded: Int = getColumnIndexOrThrow(_stmt, "added")
          val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
          val _columnIndexOfCustomSid: Int = getColumnIndexOrThrow(_stmt, "customSid")
          val _columnIndexOfDirectSource: Int = getColumnIndexOrThrow(_stmt, "directSource")
          val _columnIndexOfIsAdult: Int = getColumnIndexOrThrow(_stmt, "isAdult")
          val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
          val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
          val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
          val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
          val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
          val _columnIndexOfContainerExtension: Int = getColumnIndexOrThrow(_stmt, "containerExtension")
          val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
          val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
          val _result: MutableList<VodStream> = mutableListOf()
          while (_stmt.step()) {
            val _item: VodStream
            val _tmpAdded: String
            _tmpAdded = _stmt.getText(_columnIndexOfAdded)
            val _tmpCategoryId: Int
            _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
            val _tmpCustomSid: String?
            if (_stmt.isNull(_columnIndexOfCustomSid)) {
              _tmpCustomSid = null
            } else {
              _tmpCustomSid = _stmt.getText(_columnIndexOfCustomSid)
            }
            val _tmpDirectSource: String?
            if (_stmt.isNull(_columnIndexOfDirectSource)) {
              _tmpDirectSource = null
            } else {
              _tmpDirectSource = _stmt.getText(_columnIndexOfDirectSource)
            }
            val _tmpIsAdult: Int
            _tmpIsAdult = _stmt.getLong(_columnIndexOfIsAdult).toInt()
            val _tmpName: String
            _tmpName = _stmt.getText(_columnIndexOfName)
            val _tmpNum: Int?
            if (_stmt.isNull(_columnIndexOfNum)) {
              _tmpNum = null
            } else {
              _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
            }
            val _tmpStreamIcon: String?
            if (_stmt.isNull(_columnIndexOfStreamIcon)) {
              _tmpStreamIcon = null
            } else {
              _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
            }
            val _tmpStreamId: Int
            _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
            val _tmpStreamType: String
            _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
            val _tmpContainerExtension: String
            _tmpContainerExtension = _stmt.getText(_columnIndexOfContainerExtension)
            val _tmpRating: String?
            if (_stmt.isNull(_columnIndexOfRating)) {
              _tmpRating = null
            } else {
              _tmpRating = _stmt.getText(_columnIndexOfRating)
            }
            val _tmpRatingFiveBased: String?
            if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
              _tmpRatingFiveBased = null
            } else {
              _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
            }
            _item = VodStream(_tmpAdded,_tmpCategoryId,_tmpCustomSid,_tmpDirectSource,_tmpIsAdult,_tmpName,_tmpNum,_tmpStreamIcon,_tmpStreamId,_tmpStreamType,_tmpContainerExtension,_tmpRating,_tmpRatingFiveBased)
            _result.add(_item)
          }
          _result
        } finally {
          _stmt.close()
        }
      }
    }
  }

  public override suspend fun hasEntity(id: Int): Boolean {
    val _sql: String = "SELECT EXISTS (SELECT 1 FROM vodTable WHERE streamId = ?)"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindLong(_argIndex, id.toLong())
        val _result: Boolean
        if (_stmt.step()) {
          val _tmp: Int
          _tmp = _stmt.getLong(0).toInt()
          _result = _tmp != 0
        } else {
          _result = false
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun hasEntityAsFlow(id: Int?): Flow<Boolean> {
    val _sql: String = "SELECT EXISTS (SELECT 1 FROM vodTable WHERE streamId = ?)"
    return createFlow(__db, false, arrayOf("vodTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (id == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, id.toLong())
        }
        val _result: Boolean
        if (_stmt.step()) {
          val _tmp: Int
          _tmp = _stmt.getLong(0).toInt()
          _result = _tmp != 0
        } else {
          _result = false
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun getSize(): Long? {
    val _sql: String = "SELECT COUNT(*) FROM vodTable "
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _result: Long?
        if (_stmt.step()) {
          val _tmp: Long?
          if (_stmt.isNull(0)) {
            _tmp = null
          } else {
            _tmp = _stmt.getLong(0)
          }
          _result = _tmp
        } else {
          _result = null
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun getSize(categoryId: Int?): Long? {
    val _sql: String = "SELECT COUNT(*) FROM vodTable  WHERE (? IS NULL OR categoryId = ?)"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (categoryId == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, categoryId.toLong())
        }
        _argIndex = 2
        if (categoryId == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, categoryId.toLong())
        }
        val _result: Long?
        if (_stmt.step()) {
          val _tmp: Long?
          if (_stmt.isNull(0)) {
            _tmp = null
          } else {
            _tmp = _stmt.getLong(0)
          }
          _result = _tmp
        } else {
          _result = null
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun recentlyAdded(): List<VodStream> {
    val _sql: String = "SELECT * FROM vodTable ORDER BY added DESC LIMIT 10"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _columnIndexOfAdded: Int = getColumnIndexOrThrow(_stmt, "added")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfCustomSid: Int = getColumnIndexOrThrow(_stmt, "customSid")
        val _columnIndexOfDirectSource: Int = getColumnIndexOrThrow(_stmt, "directSource")
        val _columnIndexOfIsAdult: Int = getColumnIndexOrThrow(_stmt, "isAdult")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _columnIndexOfContainerExtension: Int = getColumnIndexOrThrow(_stmt, "containerExtension")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _result: MutableList<VodStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: VodStream
          val _tmpAdded: String
          _tmpAdded = _stmt.getText(_columnIndexOfAdded)
          val _tmpCategoryId: Int
          _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          val _tmpCustomSid: String?
          if (_stmt.isNull(_columnIndexOfCustomSid)) {
            _tmpCustomSid = null
          } else {
            _tmpCustomSid = _stmt.getText(_columnIndexOfCustomSid)
          }
          val _tmpDirectSource: String?
          if (_stmt.isNull(_columnIndexOfDirectSource)) {
            _tmpDirectSource = null
          } else {
            _tmpDirectSource = _stmt.getText(_columnIndexOfDirectSource)
          }
          val _tmpIsAdult: Int
          _tmpIsAdult = _stmt.getLong(_columnIndexOfIsAdult).toInt()
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          val _tmpContainerExtension: String
          _tmpContainerExtension = _stmt.getText(_columnIndexOfContainerExtension)
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          _item = VodStream(_tmpAdded,_tmpCategoryId,_tmpCustomSid,_tmpDirectSource,_tmpIsAdult,_tmpName,_tmpNum,_tmpStreamIcon,_tmpStreamId,_tmpStreamType,_tmpContainerExtension,_tmpRating,_tmpRatingFiveBased)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun recentlyAddedFlow(limit: Int): Flow<List<VodStream>> {
    val _sql: String = """
        |
        |        SELECT * FROM vodTable
        |        ORDER BY added DESC
        |        LIMIT ?
        |        
        """.trimMargin()
    return createFlow(__db, false, arrayOf("vodTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindLong(_argIndex, limit.toLong())
        val _columnIndexOfAdded: Int = getColumnIndexOrThrow(_stmt, "added")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfCustomSid: Int = getColumnIndexOrThrow(_stmt, "customSid")
        val _columnIndexOfDirectSource: Int = getColumnIndexOrThrow(_stmt, "directSource")
        val _columnIndexOfIsAdult: Int = getColumnIndexOrThrow(_stmt, "isAdult")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _columnIndexOfContainerExtension: Int = getColumnIndexOrThrow(_stmt, "containerExtension")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _result: MutableList<VodStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: VodStream
          val _tmpAdded: String
          _tmpAdded = _stmt.getText(_columnIndexOfAdded)
          val _tmpCategoryId: Int
          _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          val _tmpCustomSid: String?
          if (_stmt.isNull(_columnIndexOfCustomSid)) {
            _tmpCustomSid = null
          } else {
            _tmpCustomSid = _stmt.getText(_columnIndexOfCustomSid)
          }
          val _tmpDirectSource: String?
          if (_stmt.isNull(_columnIndexOfDirectSource)) {
            _tmpDirectSource = null
          } else {
            _tmpDirectSource = _stmt.getText(_columnIndexOfDirectSource)
          }
          val _tmpIsAdult: Int
          _tmpIsAdult = _stmt.getLong(_columnIndexOfIsAdult).toInt()
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          val _tmpContainerExtension: String
          _tmpContainerExtension = _stmt.getText(_columnIndexOfContainerExtension)
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          _item = VodStream(_tmpAdded,_tmpCategoryId,_tmpCustomSid,_tmpDirectSource,_tmpIsAdult,_tmpName,_tmpNum,_tmpStreamIcon,_tmpStreamId,_tmpStreamType,_tmpContainerExtension,_tmpRating,_tmpRatingFiveBased)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun getRecentlyAddedSize(): Flow<Long> {
    val _sql: String = "SELECT COUNT(*) FROM vodTable ORDER BY added DESC  LIMIT 10"
    return createFlow(__db, false, arrayOf("vodTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _result: Long
        if (_stmt.step()) {
          val _tmp: Long
          _tmp = _stmt.getLong(0)
          _result = _tmp
        } else {
          _result = 0L
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun getRecentlyAdded(limit: Int): PagingSource<Int, VodStream> {
    val _sql: String = """
        |
        |        SELECT * FROM vodTable
        |         ORDER BY added DESC
        |        LIMIT ?
        |    
        """.trimMargin()
    val _rawQuery: RoomRawQuery = RoomRawQuery(_sql) { _stmt ->
      var _argIndex: Int = 1
      _stmt.bindLong(_argIndex, limit.toLong())
    }
    return __pagingSourceDaoReturnTypeConverter.convert(__db, arrayOf("vodTable"), _rawQuery) { _converterQuery ->
      performSuspending<MutableList<VodStream>>(__db, true, false) { _connection ->
        val _stmt: SQLiteStatement = _connection.prepare(_converterQuery.sql)
        try {
          _converterQuery.getBindingFunction().invoke(_stmt)
          val _columnIndexOfAdded: Int = getColumnIndexOrThrow(_stmt, "added")
          val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
          val _columnIndexOfCustomSid: Int = getColumnIndexOrThrow(_stmt, "customSid")
          val _columnIndexOfDirectSource: Int = getColumnIndexOrThrow(_stmt, "directSource")
          val _columnIndexOfIsAdult: Int = getColumnIndexOrThrow(_stmt, "isAdult")
          val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
          val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
          val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
          val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
          val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
          val _columnIndexOfContainerExtension: Int = getColumnIndexOrThrow(_stmt, "containerExtension")
          val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
          val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
          val _result: MutableList<VodStream> = mutableListOf()
          while (_stmt.step()) {
            val _item: VodStream
            val _tmpAdded: String
            _tmpAdded = _stmt.getText(_columnIndexOfAdded)
            val _tmpCategoryId: Int
            _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
            val _tmpCustomSid: String?
            if (_stmt.isNull(_columnIndexOfCustomSid)) {
              _tmpCustomSid = null
            } else {
              _tmpCustomSid = _stmt.getText(_columnIndexOfCustomSid)
            }
            val _tmpDirectSource: String?
            if (_stmt.isNull(_columnIndexOfDirectSource)) {
              _tmpDirectSource = null
            } else {
              _tmpDirectSource = _stmt.getText(_columnIndexOfDirectSource)
            }
            val _tmpIsAdult: Int
            _tmpIsAdult = _stmt.getLong(_columnIndexOfIsAdult).toInt()
            val _tmpName: String
            _tmpName = _stmt.getText(_columnIndexOfName)
            val _tmpNum: Int?
            if (_stmt.isNull(_columnIndexOfNum)) {
              _tmpNum = null
            } else {
              _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
            }
            val _tmpStreamIcon: String?
            if (_stmt.isNull(_columnIndexOfStreamIcon)) {
              _tmpStreamIcon = null
            } else {
              _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
            }
            val _tmpStreamId: Int
            _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
            val _tmpStreamType: String
            _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
            val _tmpContainerExtension: String
            _tmpContainerExtension = _stmt.getText(_columnIndexOfContainerExtension)
            val _tmpRating: String?
            if (_stmt.isNull(_columnIndexOfRating)) {
              _tmpRating = null
            } else {
              _tmpRating = _stmt.getText(_columnIndexOfRating)
            }
            val _tmpRatingFiveBased: String?
            if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
              _tmpRatingFiveBased = null
            } else {
              _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
            }
            _item = VodStream(_tmpAdded,_tmpCategoryId,_tmpCustomSid,_tmpDirectSource,_tmpIsAdult,_tmpName,_tmpNum,_tmpStreamIcon,_tmpStreamId,_tmpStreamType,_tmpContainerExtension,_tmpRating,_tmpRatingFiveBased)
            _result.add(_item)
          }
          _result
        } finally {
          _stmt.close()
        }
      }
    }
  }

  public override fun getRecentlyAddedFlow(limit: Int): Flow<List<VodStream>> {
    val _sql: String = """
        |
        |        SELECT * FROM vodTable
        |         ORDER BY added DESC
        |        LIMIT ?
        |    
        """.trimMargin()
    return createFlow(__db, false, arrayOf("vodTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindLong(_argIndex, limit.toLong())
        val _columnIndexOfAdded: Int = getColumnIndexOrThrow(_stmt, "added")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfCustomSid: Int = getColumnIndexOrThrow(_stmt, "customSid")
        val _columnIndexOfDirectSource: Int = getColumnIndexOrThrow(_stmt, "directSource")
        val _columnIndexOfIsAdult: Int = getColumnIndexOrThrow(_stmt, "isAdult")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _columnIndexOfContainerExtension: Int = getColumnIndexOrThrow(_stmt, "containerExtension")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _result: MutableList<VodStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: VodStream
          val _tmpAdded: String
          _tmpAdded = _stmt.getText(_columnIndexOfAdded)
          val _tmpCategoryId: Int
          _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          val _tmpCustomSid: String?
          if (_stmt.isNull(_columnIndexOfCustomSid)) {
            _tmpCustomSid = null
          } else {
            _tmpCustomSid = _stmt.getText(_columnIndexOfCustomSid)
          }
          val _tmpDirectSource: String?
          if (_stmt.isNull(_columnIndexOfDirectSource)) {
            _tmpDirectSource = null
          } else {
            _tmpDirectSource = _stmt.getText(_columnIndexOfDirectSource)
          }
          val _tmpIsAdult: Int
          _tmpIsAdult = _stmt.getLong(_columnIndexOfIsAdult).toInt()
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          val _tmpContainerExtension: String
          _tmpContainerExtension = _stmt.getText(_columnIndexOfContainerExtension)
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          _item = VodStream(_tmpAdded,_tmpCategoryId,_tmpCustomSid,_tmpDirectSource,_tmpIsAdult,_tmpName,_tmpNum,_tmpStreamIcon,_tmpStreamId,_tmpStreamType,_tmpContainerExtension,_tmpRating,_tmpRatingFiveBased)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun getRecommendations(categoryId: Int?, limit: Int): PagingSource<Int, VodStream> {
    val _sql: String = """
        |
        |        SELECT * FROM vodTable
        |        WHERE (? IS NULL OR categoryId = ?)
        |        ORDER BY RANDOM() 
        |        LIMIT ?
        |    
        """.trimMargin()
    val _rawQuery: RoomRawQuery = RoomRawQuery(_sql) { _stmt ->
      var _argIndex: Int = 1
      if (categoryId == null) {
        _stmt.bindNull(_argIndex)
      } else {
        _stmt.bindLong(_argIndex, categoryId.toLong())
      }
      _argIndex = 2
      if (categoryId == null) {
        _stmt.bindNull(_argIndex)
      } else {
        _stmt.bindLong(_argIndex, categoryId.toLong())
      }
      _argIndex = 3
      _stmt.bindLong(_argIndex, limit.toLong())
    }
    return __pagingSourceDaoReturnTypeConverter.convert(__db, arrayOf("vodTable"), _rawQuery) { _converterQuery ->
      performSuspending<MutableList<VodStream>>(__db, true, false) { _connection ->
        val _stmt: SQLiteStatement = _connection.prepare(_converterQuery.sql)
        try {
          _converterQuery.getBindingFunction().invoke(_stmt)
          val _columnIndexOfAdded: Int = getColumnIndexOrThrow(_stmt, "added")
          val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
          val _columnIndexOfCustomSid: Int = getColumnIndexOrThrow(_stmt, "customSid")
          val _columnIndexOfDirectSource: Int = getColumnIndexOrThrow(_stmt, "directSource")
          val _columnIndexOfIsAdult: Int = getColumnIndexOrThrow(_stmt, "isAdult")
          val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
          val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
          val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
          val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
          val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
          val _columnIndexOfContainerExtension: Int = getColumnIndexOrThrow(_stmt, "containerExtension")
          val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
          val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
          val _result: MutableList<VodStream> = mutableListOf()
          while (_stmt.step()) {
            val _item: VodStream
            val _tmpAdded: String
            _tmpAdded = _stmt.getText(_columnIndexOfAdded)
            val _tmpCategoryId: Int
            _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
            val _tmpCustomSid: String?
            if (_stmt.isNull(_columnIndexOfCustomSid)) {
              _tmpCustomSid = null
            } else {
              _tmpCustomSid = _stmt.getText(_columnIndexOfCustomSid)
            }
            val _tmpDirectSource: String?
            if (_stmt.isNull(_columnIndexOfDirectSource)) {
              _tmpDirectSource = null
            } else {
              _tmpDirectSource = _stmt.getText(_columnIndexOfDirectSource)
            }
            val _tmpIsAdult: Int
            _tmpIsAdult = _stmt.getLong(_columnIndexOfIsAdult).toInt()
            val _tmpName: String
            _tmpName = _stmt.getText(_columnIndexOfName)
            val _tmpNum: Int?
            if (_stmt.isNull(_columnIndexOfNum)) {
              _tmpNum = null
            } else {
              _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
            }
            val _tmpStreamIcon: String?
            if (_stmt.isNull(_columnIndexOfStreamIcon)) {
              _tmpStreamIcon = null
            } else {
              _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
            }
            val _tmpStreamId: Int
            _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
            val _tmpStreamType: String
            _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
            val _tmpContainerExtension: String
            _tmpContainerExtension = _stmt.getText(_columnIndexOfContainerExtension)
            val _tmpRating: String?
            if (_stmt.isNull(_columnIndexOfRating)) {
              _tmpRating = null
            } else {
              _tmpRating = _stmt.getText(_columnIndexOfRating)
            }
            val _tmpRatingFiveBased: String?
            if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
              _tmpRatingFiveBased = null
            } else {
              _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
            }
            _item = VodStream(_tmpAdded,_tmpCategoryId,_tmpCustomSid,_tmpDirectSource,_tmpIsAdult,_tmpName,_tmpNum,_tmpStreamIcon,_tmpStreamId,_tmpStreamType,_tmpContainerExtension,_tmpRating,_tmpRatingFiveBased)
            _result.add(_item)
          }
          _result
        } finally {
          _stmt.close()
        }
      }
    }
  }

  public override suspend fun getFavoriteStreams(limit: Int?): List<VodStream> {
    val _sql: String = "SELECT vodTable.*, vodFavoritesTable.sortOrder AS  'num'  FROM vodTable INNER JOIN vodFavoritesTable ON vodTable.streamId = vodFavoritesTable.streamId ORDER BY vodFavoritesTable.sortOrder ASC LIMIT ?"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (limit == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, limit.toLong())
        }
        val _columnIndexOfAdded: Int = getColumnIndexOrThrow(_stmt, "added")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfCustomSid: Int = getColumnIndexOrThrow(_stmt, "customSid")
        val _columnIndexOfDirectSource: Int = getColumnIndexOrThrow(_stmt, "directSource")
        val _columnIndexOfIsAdult: Int = getColumnIndexOrThrow(_stmt, "isAdult")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _columnIndexOfContainerExtension: Int = getColumnIndexOrThrow(_stmt, "containerExtension")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _result: MutableList<VodStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: VodStream
          val _tmpAdded: String
          _tmpAdded = _stmt.getText(_columnIndexOfAdded)
          val _tmpCategoryId: Int
          _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          val _tmpCustomSid: String?
          if (_stmt.isNull(_columnIndexOfCustomSid)) {
            _tmpCustomSid = null
          } else {
            _tmpCustomSid = _stmt.getText(_columnIndexOfCustomSid)
          }
          val _tmpDirectSource: String?
          if (_stmt.isNull(_columnIndexOfDirectSource)) {
            _tmpDirectSource = null
          } else {
            _tmpDirectSource = _stmt.getText(_columnIndexOfDirectSource)
          }
          val _tmpIsAdult: Int
          _tmpIsAdult = _stmt.getLong(_columnIndexOfIsAdult).toInt()
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          val _tmpContainerExtension: String
          _tmpContainerExtension = _stmt.getText(_columnIndexOfContainerExtension)
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          _item = VodStream(_tmpAdded,_tmpCategoryId,_tmpCustomSid,_tmpDirectSource,_tmpIsAdult,_tmpName,_tmpNum,_tmpStreamIcon,_tmpStreamId,_tmpStreamType,_tmpContainerExtension,_tmpRating,_tmpRatingFiveBased)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun getFavoriteStreams(): List<VodStream> {
    val _sql: String = "SELECT vodTable.*, vodFavoritesTable.sortOrder AS  'num'  FROM vodTable INNER JOIN vodFavoritesTable ON vodTable.streamId = vodFavoritesTable.streamId ORDER BY vodFavoritesTable.sortOrder ASC"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _columnIndexOfAdded: Int = getColumnIndexOrThrow(_stmt, "added")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfCustomSid: Int = getColumnIndexOrThrow(_stmt, "customSid")
        val _columnIndexOfDirectSource: Int = getColumnIndexOrThrow(_stmt, "directSource")
        val _columnIndexOfIsAdult: Int = getColumnIndexOrThrow(_stmt, "isAdult")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _columnIndexOfContainerExtension: Int = getColumnIndexOrThrow(_stmt, "containerExtension")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _result: MutableList<VodStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: VodStream
          val _tmpAdded: String
          _tmpAdded = _stmt.getText(_columnIndexOfAdded)
          val _tmpCategoryId: Int
          _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          val _tmpCustomSid: String?
          if (_stmt.isNull(_columnIndexOfCustomSid)) {
            _tmpCustomSid = null
          } else {
            _tmpCustomSid = _stmt.getText(_columnIndexOfCustomSid)
          }
          val _tmpDirectSource: String?
          if (_stmt.isNull(_columnIndexOfDirectSource)) {
            _tmpDirectSource = null
          } else {
            _tmpDirectSource = _stmt.getText(_columnIndexOfDirectSource)
          }
          val _tmpIsAdult: Int
          _tmpIsAdult = _stmt.getLong(_columnIndexOfIsAdult).toInt()
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          val _tmpContainerExtension: String
          _tmpContainerExtension = _stmt.getText(_columnIndexOfContainerExtension)
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          _item = VodStream(_tmpAdded,_tmpCategoryId,_tmpCustomSid,_tmpDirectSource,_tmpIsAdult,_tmpName,_tmpNum,_tmpStreamIcon,_tmpStreamId,_tmpStreamType,_tmpContainerExtension,_tmpRating,_tmpRatingFiveBased)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun getFavoriteStreamsFlow(limit: Int?): Flow<List<VodStream>> {
    val _sql: String = """
        |SELECT vodTable.*, vodFavoritesTable.sortOrder AS  'num' 
        |             FROM vodTable 
        |            INNER JOIN vodFavoritesTable ON vodTable.streamId = vodFavoritesTable.streamId 
        |            ORDER BY vodFavoritesTable.sortOrder ASC 
        |             LIMIT ?
        """.trimMargin()
    return createFlow(__db, false, arrayOf("vodTable", "vodFavoritesTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (limit == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, limit.toLong())
        }
        val _columnIndexOfAdded: Int = getColumnIndexOrThrow(_stmt, "added")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfCustomSid: Int = getColumnIndexOrThrow(_stmt, "customSid")
        val _columnIndexOfDirectSource: Int = getColumnIndexOrThrow(_stmt, "directSource")
        val _columnIndexOfIsAdult: Int = getColumnIndexOrThrow(_stmt, "isAdult")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _columnIndexOfContainerExtension: Int = getColumnIndexOrThrow(_stmt, "containerExtension")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _result: MutableList<VodStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: VodStream
          val _tmpAdded: String
          _tmpAdded = _stmt.getText(_columnIndexOfAdded)
          val _tmpCategoryId: Int
          _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          val _tmpCustomSid: String?
          if (_stmt.isNull(_columnIndexOfCustomSid)) {
            _tmpCustomSid = null
          } else {
            _tmpCustomSid = _stmt.getText(_columnIndexOfCustomSid)
          }
          val _tmpDirectSource: String?
          if (_stmt.isNull(_columnIndexOfDirectSource)) {
            _tmpDirectSource = null
          } else {
            _tmpDirectSource = _stmt.getText(_columnIndexOfDirectSource)
          }
          val _tmpIsAdult: Int
          _tmpIsAdult = _stmt.getLong(_columnIndexOfIsAdult).toInt()
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          val _tmpContainerExtension: String
          _tmpContainerExtension = _stmt.getText(_columnIndexOfContainerExtension)
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          _item = VodStream(_tmpAdded,_tmpCategoryId,_tmpCustomSid,_tmpDirectSource,_tmpIsAdult,_tmpName,_tmpNum,_tmpStreamIcon,_tmpStreamId,_tmpStreamType,_tmpContainerExtension,_tmpRating,_tmpRatingFiveBased)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun getPagedFavoriteStreams(): PagingSource<Int, VodStream> {
    val _sql: String = "SELECT vodTable.*, vodFavoritesTable.sortOrder AS  'num'  FROM vodTable INNER JOIN vodFavoritesTable ON vodTable.streamId = vodFavoritesTable.streamId ORDER BY vodFavoritesTable.sortOrder ASC"
    val _rawQuery: RoomRawQuery = RoomRawQuery(_sql)
    return __pagingSourceDaoReturnTypeConverter.convert(__db, arrayOf("vodTable", "vodFavoritesTable"), _rawQuery) { _converterQuery ->
      performSuspending<MutableList<VodStream>>(__db, true, false) { _connection ->
        val _stmt: SQLiteStatement = _connection.prepare(_converterQuery.sql)
        try {
          _converterQuery.getBindingFunction().invoke(_stmt)
          val _columnIndexOfAdded: Int = getColumnIndexOrThrow(_stmt, "added")
          val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
          val _columnIndexOfCustomSid: Int = getColumnIndexOrThrow(_stmt, "customSid")
          val _columnIndexOfDirectSource: Int = getColumnIndexOrThrow(_stmt, "directSource")
          val _columnIndexOfIsAdult: Int = getColumnIndexOrThrow(_stmt, "isAdult")
          val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
          val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
          val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
          val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
          val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
          val _columnIndexOfContainerExtension: Int = getColumnIndexOrThrow(_stmt, "containerExtension")
          val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
          val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
          val _result: MutableList<VodStream> = mutableListOf()
          while (_stmt.step()) {
            val _item: VodStream
            val _tmpAdded: String
            _tmpAdded = _stmt.getText(_columnIndexOfAdded)
            val _tmpCategoryId: Int
            _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
            val _tmpCustomSid: String?
            if (_stmt.isNull(_columnIndexOfCustomSid)) {
              _tmpCustomSid = null
            } else {
              _tmpCustomSid = _stmt.getText(_columnIndexOfCustomSid)
            }
            val _tmpDirectSource: String?
            if (_stmt.isNull(_columnIndexOfDirectSource)) {
              _tmpDirectSource = null
            } else {
              _tmpDirectSource = _stmt.getText(_columnIndexOfDirectSource)
            }
            val _tmpIsAdult: Int
            _tmpIsAdult = _stmt.getLong(_columnIndexOfIsAdult).toInt()
            val _tmpName: String
            _tmpName = _stmt.getText(_columnIndexOfName)
            val _tmpNum: Int?
            if (_stmt.isNull(_columnIndexOfNum)) {
              _tmpNum = null
            } else {
              _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
            }
            val _tmpStreamIcon: String?
            if (_stmt.isNull(_columnIndexOfStreamIcon)) {
              _tmpStreamIcon = null
            } else {
              _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
            }
            val _tmpStreamId: Int
            _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
            val _tmpStreamType: String
            _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
            val _tmpContainerExtension: String
            _tmpContainerExtension = _stmt.getText(_columnIndexOfContainerExtension)
            val _tmpRating: String?
            if (_stmt.isNull(_columnIndexOfRating)) {
              _tmpRating = null
            } else {
              _tmpRating = _stmt.getText(_columnIndexOfRating)
            }
            val _tmpRatingFiveBased: String?
            if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
              _tmpRatingFiveBased = null
            } else {
              _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
            }
            _item = VodStream(_tmpAdded,_tmpCategoryId,_tmpCustomSid,_tmpDirectSource,_tmpIsAdult,_tmpName,_tmpNum,_tmpStreamIcon,_tmpStreamId,_tmpStreamType,_tmpContainerExtension,_tmpRating,_tmpRatingFiveBased)
            _result.add(_item)
          }
          _result
        } finally {
          _stmt.close()
        }
      }
    }
  }

  public override fun getPagedWatchedStreams(): PagingSource<Int, VodStream> {
    val _sql: String = "SELECT *  FROM vodTable INNER JOIN watchedVodStreamsTable ON vodTable.streamId = watchedVodStreamsTable.streamId     ORDER BY watchedVodStreamsTable.added DESC"
    val _rawQuery: RoomRawQuery = RoomRawQuery(_sql)
    return __pagingSourceDaoReturnTypeConverter.convert(__db, arrayOf("vodTable", "watchedVodStreamsTable"), _rawQuery) { _converterQuery ->
      performSuspending<MutableList<VodStream>>(__db, true, false) { _connection ->
        val _stmt: SQLiteStatement = _connection.prepare(_converterQuery.sql)
        try {
          _converterQuery.getBindingFunction().invoke(_stmt)
          val _columnIndexOfAdded: Int = getColumnIndexOrThrow(_stmt, "added")
          val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
          val _columnIndexOfCustomSid: Int = getColumnIndexOrThrow(_stmt, "customSid")
          val _columnIndexOfDirectSource: Int = getColumnIndexOrThrow(_stmt, "directSource")
          val _columnIndexOfIsAdult: Int = getColumnIndexOrThrow(_stmt, "isAdult")
          val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
          val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
          val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
          val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
          val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
          val _columnIndexOfContainerExtension: Int = getColumnIndexOrThrow(_stmt, "containerExtension")
          val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
          val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
          val _result: MutableList<VodStream> = mutableListOf()
          while (_stmt.step()) {
            val _item: VodStream
            val _tmpAdded: String
            _tmpAdded = _stmt.getText(_columnIndexOfAdded)
            val _tmpCategoryId: Int
            _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
            val _tmpCustomSid: String?
            if (_stmt.isNull(_columnIndexOfCustomSid)) {
              _tmpCustomSid = null
            } else {
              _tmpCustomSid = _stmt.getText(_columnIndexOfCustomSid)
            }
            val _tmpDirectSource: String?
            if (_stmt.isNull(_columnIndexOfDirectSource)) {
              _tmpDirectSource = null
            } else {
              _tmpDirectSource = _stmt.getText(_columnIndexOfDirectSource)
            }
            val _tmpIsAdult: Int
            _tmpIsAdult = _stmt.getLong(_columnIndexOfIsAdult).toInt()
            val _tmpName: String
            _tmpName = _stmt.getText(_columnIndexOfName)
            val _tmpNum: Int?
            if (_stmt.isNull(_columnIndexOfNum)) {
              _tmpNum = null
            } else {
              _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
            }
            val _tmpStreamIcon: String?
            if (_stmt.isNull(_columnIndexOfStreamIcon)) {
              _tmpStreamIcon = null
            } else {
              _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
            }
            val _tmpStreamId: Int
            _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
            val _tmpStreamType: String
            _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
            val _tmpContainerExtension: String
            _tmpContainerExtension = _stmt.getText(_columnIndexOfContainerExtension)
            val _tmpRating: String?
            if (_stmt.isNull(_columnIndexOfRating)) {
              _tmpRating = null
            } else {
              _tmpRating = _stmt.getText(_columnIndexOfRating)
            }
            val _tmpRatingFiveBased: String?
            if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
              _tmpRatingFiveBased = null
            } else {
              _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
            }
            _item = VodStream(_tmpAdded,_tmpCategoryId,_tmpCustomSid,_tmpDirectSource,_tmpIsAdult,_tmpName,_tmpNum,_tmpStreamIcon,_tmpStreamId,_tmpStreamType,_tmpContainerExtension,_tmpRating,_tmpRatingFiveBased)
            _result.add(_item)
          }
          _result
        } finally {
          _stmt.close()
        }
      }
    }
  }

  public override fun getWatchedStreamsFlow(limit: Int?): Flow<List<VodStream>> {
    val _sql: String = """
        |
        |    SELECT * FROM vodTable 
        |    INNER JOIN watchedVodStreamsTable 
        |    ON vodTable.streamId = watchedVodStreamsTable.streamId 
        |    ORDER BY watchedVodStreamsTable.added DESC 
        |    LIMIT ?
        |""".trimMargin()
    return createFlow(__db, false, arrayOf("vodTable", "watchedVodStreamsTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (limit == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, limit.toLong())
        }
        val _columnIndexOfAdded: Int = getColumnIndexOrThrow(_stmt, "added")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfCustomSid: Int = getColumnIndexOrThrow(_stmt, "customSid")
        val _columnIndexOfDirectSource: Int = getColumnIndexOrThrow(_stmt, "directSource")
        val _columnIndexOfIsAdult: Int = getColumnIndexOrThrow(_stmt, "isAdult")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _columnIndexOfContainerExtension: Int = getColumnIndexOrThrow(_stmt, "containerExtension")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _result: MutableList<VodStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: VodStream
          val _tmpAdded: String
          _tmpAdded = _stmt.getText(_columnIndexOfAdded)
          val _tmpCategoryId: Int
          _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          val _tmpCustomSid: String?
          if (_stmt.isNull(_columnIndexOfCustomSid)) {
            _tmpCustomSid = null
          } else {
            _tmpCustomSid = _stmt.getText(_columnIndexOfCustomSid)
          }
          val _tmpDirectSource: String?
          if (_stmt.isNull(_columnIndexOfDirectSource)) {
            _tmpDirectSource = null
          } else {
            _tmpDirectSource = _stmt.getText(_columnIndexOfDirectSource)
          }
          val _tmpIsAdult: Int
          _tmpIsAdult = _stmt.getLong(_columnIndexOfIsAdult).toInt()
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          val _tmpContainerExtension: String
          _tmpContainerExtension = _stmt.getText(_columnIndexOfContainerExtension)
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          _item = VodStream(_tmpAdded,_tmpCategoryId,_tmpCustomSid,_tmpDirectSource,_tmpIsAdult,_tmpName,_tmpNum,_tmpStreamIcon,_tmpStreamId,_tmpStreamType,_tmpContainerExtension,_tmpRating,_tmpRatingFiveBased)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun getSizeAsFlow(categoryId: Int?): Flow<Long?> {
    val _sql: String = "SELECT COUNT(*) FROM vodTable WHERE (? IS NULL OR categoryId = ?)"
    return createFlow(__db, false, arrayOf("vodTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (categoryId == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, categoryId.toLong())
        }
        _argIndex = 2
        if (categoryId == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, categoryId.toLong())
        }
        val _result: Long?
        if (_stmt.step()) {
          val _tmp: Long?
          if (_stmt.isNull(0)) {
            _tmp = null
          } else {
            _tmp = _stmt.getLong(0)
          }
          _result = _tmp
        } else {
          _result = null
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun getStreamById(id: Int?): VodStream? {
    val _sql: String = "SELECT * FROM vodTable WHERE streamId = ? LIMIT 1"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (id == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, id.toLong())
        }
        val _columnIndexOfAdded: Int = getColumnIndexOrThrow(_stmt, "added")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfCustomSid: Int = getColumnIndexOrThrow(_stmt, "customSid")
        val _columnIndexOfDirectSource: Int = getColumnIndexOrThrow(_stmt, "directSource")
        val _columnIndexOfIsAdult: Int = getColumnIndexOrThrow(_stmt, "isAdult")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _columnIndexOfContainerExtension: Int = getColumnIndexOrThrow(_stmt, "containerExtension")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _result: VodStream?
        if (_stmt.step()) {
          val _tmpAdded: String
          _tmpAdded = _stmt.getText(_columnIndexOfAdded)
          val _tmpCategoryId: Int
          _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          val _tmpCustomSid: String?
          if (_stmt.isNull(_columnIndexOfCustomSid)) {
            _tmpCustomSid = null
          } else {
            _tmpCustomSid = _stmt.getText(_columnIndexOfCustomSid)
          }
          val _tmpDirectSource: String?
          if (_stmt.isNull(_columnIndexOfDirectSource)) {
            _tmpDirectSource = null
          } else {
            _tmpDirectSource = _stmt.getText(_columnIndexOfDirectSource)
          }
          val _tmpIsAdult: Int
          _tmpIsAdult = _stmt.getLong(_columnIndexOfIsAdult).toInt()
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          val _tmpContainerExtension: String
          _tmpContainerExtension = _stmt.getText(_columnIndexOfContainerExtension)
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          _result = VodStream(_tmpAdded,_tmpCategoryId,_tmpCustomSid,_tmpDirectSource,_tmpIsAdult,_tmpName,_tmpNum,_tmpStreamIcon,_tmpStreamId,_tmpStreamType,_tmpContainerExtension,_tmpRating,_tmpRatingFiveBased)
        } else {
          _result = null
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun all(
    categoryId: Int?,
    nameQuery: String?,
    limit: Int?,
    offset: Int?,
  ): List<VodStream> {
    val _sql: String = "SELECT * FROM vodTable WHERE (? IS NULL OR categoryId = ?) AND (? IS NULL OR name LIKE '%' || ? || '%')  ORDER BY added DESC LIMIT ? OFFSET ?"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (categoryId == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, categoryId.toLong())
        }
        _argIndex = 2
        if (categoryId == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, categoryId.toLong())
        }
        _argIndex = 3
        if (nameQuery == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindText(_argIndex, nameQuery)
        }
        _argIndex = 4
        if (nameQuery == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindText(_argIndex, nameQuery)
        }
        _argIndex = 5
        if (limit == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, limit.toLong())
        }
        _argIndex = 6
        if (offset == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, offset.toLong())
        }
        val _columnIndexOfAdded: Int = getColumnIndexOrThrow(_stmt, "added")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfCustomSid: Int = getColumnIndexOrThrow(_stmt, "customSid")
        val _columnIndexOfDirectSource: Int = getColumnIndexOrThrow(_stmt, "directSource")
        val _columnIndexOfIsAdult: Int = getColumnIndexOrThrow(_stmt, "isAdult")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _columnIndexOfContainerExtension: Int = getColumnIndexOrThrow(_stmt, "containerExtension")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _result: MutableList<VodStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: VodStream
          val _tmpAdded: String
          _tmpAdded = _stmt.getText(_columnIndexOfAdded)
          val _tmpCategoryId: Int
          _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          val _tmpCustomSid: String?
          if (_stmt.isNull(_columnIndexOfCustomSid)) {
            _tmpCustomSid = null
          } else {
            _tmpCustomSid = _stmt.getText(_columnIndexOfCustomSid)
          }
          val _tmpDirectSource: String?
          if (_stmt.isNull(_columnIndexOfDirectSource)) {
            _tmpDirectSource = null
          } else {
            _tmpDirectSource = _stmt.getText(_columnIndexOfDirectSource)
          }
          val _tmpIsAdult: Int
          _tmpIsAdult = _stmt.getLong(_columnIndexOfIsAdult).toInt()
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          val _tmpContainerExtension: String
          _tmpContainerExtension = _stmt.getText(_columnIndexOfContainerExtension)
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          _item = VodStream(_tmpAdded,_tmpCategoryId,_tmpCustomSid,_tmpDirectSource,_tmpIsAdult,_tmpName,_tmpNum,_tmpStreamIcon,_tmpStreamId,_tmpStreamType,_tmpContainerExtension,_tmpRating,_tmpRatingFiveBased)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun getRecentlyAddedList(limit: Int): List<VodStream> {
    val _sql: String = """
        |
        |        SELECT * FROM vodTable
        |         ORDER BY added DESC
        |        LIMIT ?
        |    
        """.trimMargin()
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindLong(_argIndex, limit.toLong())
        val _columnIndexOfAdded: Int = getColumnIndexOrThrow(_stmt, "added")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfCustomSid: Int = getColumnIndexOrThrow(_stmt, "customSid")
        val _columnIndexOfDirectSource: Int = getColumnIndexOrThrow(_stmt, "directSource")
        val _columnIndexOfIsAdult: Int = getColumnIndexOrThrow(_stmt, "isAdult")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _columnIndexOfContainerExtension: Int = getColumnIndexOrThrow(_stmt, "containerExtension")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _result: MutableList<VodStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: VodStream
          val _tmpAdded: String
          _tmpAdded = _stmt.getText(_columnIndexOfAdded)
          val _tmpCategoryId: Int
          _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          val _tmpCustomSid: String?
          if (_stmt.isNull(_columnIndexOfCustomSid)) {
            _tmpCustomSid = null
          } else {
            _tmpCustomSid = _stmt.getText(_columnIndexOfCustomSid)
          }
          val _tmpDirectSource: String?
          if (_stmt.isNull(_columnIndexOfDirectSource)) {
            _tmpDirectSource = null
          } else {
            _tmpDirectSource = _stmt.getText(_columnIndexOfDirectSource)
          }
          val _tmpIsAdult: Int
          _tmpIsAdult = _stmt.getLong(_columnIndexOfIsAdult).toInt()
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          val _tmpContainerExtension: String
          _tmpContainerExtension = _stmt.getText(_columnIndexOfContainerExtension)
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          _item = VodStream(_tmpAdded,_tmpCategoryId,_tmpCustomSid,_tmpDirectSource,_tmpIsAdult,_tmpName,_tmpNum,_tmpStreamIcon,_tmpStreamId,_tmpStreamType,_tmpContainerExtension,_tmpRating,_tmpRatingFiveBased)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun getRecommendationsList(
    categoryId: Int?,
    limit: Int,
    excludeIds: List<Int?>?,
  ): Flow<List<VodStream>> {
    val _stringBuilder: StringBuilder = StringBuilder()
    _stringBuilder.append("""
        |
        |""".trimMargin())
    _stringBuilder.append("    SELECT * FROM vodTable")
    _stringBuilder.append("""
        |
        |""".trimMargin())
    _stringBuilder.append("    WHERE (")
    _stringBuilder.append("?")
    _stringBuilder.append(" IS NULL OR categoryId = ")
    _stringBuilder.append("?")
    _stringBuilder.append(")")
    _stringBuilder.append("""
        |
        |""".trimMargin())
    _stringBuilder.append("    AND (")
    val _inputSize: Int = if (excludeIds == null) 1 else excludeIds.size
    appendPlaceholders(_stringBuilder, _inputSize)
    _stringBuilder.append(" IS NULL OR streamId NOT IN (")
    val _inputSize_1: Int = if (excludeIds == null) 1 else excludeIds.size
    appendPlaceholders(_stringBuilder, _inputSize_1)
    _stringBuilder.append("))")
    _stringBuilder.append("""
        |
        |""".trimMargin())
    _stringBuilder.append("    ORDER BY RANDOM()")
    _stringBuilder.append("""
        |
        |""".trimMargin())
    _stringBuilder.append("    LIMIT ")
    _stringBuilder.append("?")
    _stringBuilder.append("""
        |
        |""".trimMargin())
    val _sql: String = _stringBuilder.toString()
    return createFlow(__db, false, arrayOf("vodTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (categoryId == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, categoryId.toLong())
        }
        _argIndex = 2
        if (categoryId == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, categoryId.toLong())
        }
        _argIndex = 3
        if (excludeIds == null) {
          _stmt.bindNull(_argIndex)
        } else {
          for (_item: Int? in excludeIds) {
            if (_item == null) {
              _stmt.bindNull(_argIndex)
            } else {
              _stmt.bindLong(_argIndex, _item.toLong())
            }
            _argIndex++
          }
        }
        _argIndex = 3 + _inputSize
        if (excludeIds == null) {
          _stmt.bindNull(_argIndex)
        } else {
          for (_item_1: Int? in excludeIds) {
            if (_item_1 == null) {
              _stmt.bindNull(_argIndex)
            } else {
              _stmt.bindLong(_argIndex, _item_1.toLong())
            }
            _argIndex++
          }
        }
        _argIndex = 3 + _inputSize + _inputSize
        _stmt.bindLong(_argIndex, limit.toLong())
        val _columnIndexOfAdded: Int = getColumnIndexOrThrow(_stmt, "added")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfCustomSid: Int = getColumnIndexOrThrow(_stmt, "customSid")
        val _columnIndexOfDirectSource: Int = getColumnIndexOrThrow(_stmt, "directSource")
        val _columnIndexOfIsAdult: Int = getColumnIndexOrThrow(_stmt, "isAdult")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _columnIndexOfContainerExtension: Int = getColumnIndexOrThrow(_stmt, "containerExtension")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _result: MutableList<VodStream> = mutableListOf()
        while (_stmt.step()) {
          val _item_2: VodStream
          val _tmpAdded: String
          _tmpAdded = _stmt.getText(_columnIndexOfAdded)
          val _tmpCategoryId: Int
          _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          val _tmpCustomSid: String?
          if (_stmt.isNull(_columnIndexOfCustomSid)) {
            _tmpCustomSid = null
          } else {
            _tmpCustomSid = _stmt.getText(_columnIndexOfCustomSid)
          }
          val _tmpDirectSource: String?
          if (_stmt.isNull(_columnIndexOfDirectSource)) {
            _tmpDirectSource = null
          } else {
            _tmpDirectSource = _stmt.getText(_columnIndexOfDirectSource)
          }
          val _tmpIsAdult: Int
          _tmpIsAdult = _stmt.getLong(_columnIndexOfIsAdult).toInt()
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          val _tmpContainerExtension: String
          _tmpContainerExtension = _stmt.getText(_columnIndexOfContainerExtension)
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          _item_2 = VodStream(_tmpAdded,_tmpCategoryId,_tmpCustomSid,_tmpDirectSource,_tmpIsAdult,_tmpName,_tmpNum,_tmpStreamIcon,_tmpStreamId,_tmpStreamType,_tmpContainerExtension,_tmpRating,_tmpRatingFiveBased)
          _result.add(_item_2)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun getWatchedStreams(limit: Int?): List<VodStream> {
    val _sql: String = "SELECT *  FROM vodTable INNER JOIN watchedVodStreamsTable ON vodTable.streamId = watchedVodStreamsTable.streamId  ORDER BY watchedVodStreamsTable.added DESC LIMIT ?"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (limit == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, limit.toLong())
        }
        val _columnIndexOfAdded: Int = getColumnIndexOrThrow(_stmt, "added")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfCustomSid: Int = getColumnIndexOrThrow(_stmt, "customSid")
        val _columnIndexOfDirectSource: Int = getColumnIndexOrThrow(_stmt, "directSource")
        val _columnIndexOfIsAdult: Int = getColumnIndexOrThrow(_stmt, "isAdult")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _columnIndexOfContainerExtension: Int = getColumnIndexOrThrow(_stmt, "containerExtension")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _result: MutableList<VodStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: VodStream
          val _tmpAdded: String
          _tmpAdded = _stmt.getText(_columnIndexOfAdded)
          val _tmpCategoryId: Int
          _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          val _tmpCustomSid: String?
          if (_stmt.isNull(_columnIndexOfCustomSid)) {
            _tmpCustomSid = null
          } else {
            _tmpCustomSid = _stmt.getText(_columnIndexOfCustomSid)
          }
          val _tmpDirectSource: String?
          if (_stmt.isNull(_columnIndexOfDirectSource)) {
            _tmpDirectSource = null
          } else {
            _tmpDirectSource = _stmt.getText(_columnIndexOfDirectSource)
          }
          val _tmpIsAdult: Int
          _tmpIsAdult = _stmt.getLong(_columnIndexOfIsAdult).toInt()
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          val _tmpContainerExtension: String
          _tmpContainerExtension = _stmt.getText(_columnIndexOfContainerExtension)
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          _item = VodStream(_tmpAdded,_tmpCategoryId,_tmpCustomSid,_tmpDirectSource,_tmpIsAdult,_tmpName,_tmpNum,_tmpStreamIcon,_tmpStreamId,_tmpStreamType,_tmpContainerExtension,_tmpRating,_tmpRatingFiveBased)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun getWatchedStreamsAsIntermediateFlow(limit: Int?): Flow<List<WatchedIntermediateVodStream>> {
    val _sql: String = """
        |SELECT 
        |watchedVodStreamsTable.streamId AS watched_streamId, 
        |watchedVodStreamsTable.added AS watched_added, 
        |watchedVodStreamsTable.progress AS watched_progress, 
        |watchedVodStreamsTable.totalProgress AS watched_totalProgress, 
        |watchedVodStreamsTable.backdrop AS watched_backdrop, 
        |        vodTable.*
        |         FROM vodTable
        |            INNER JOIN watchedVodStreamsTable 
        |            ON vodTable.streamId = watchedVodStreamsTable.streamId
        |            ORDER BY watchedVodStreamsTable.added DESC LIMIT ?            
        |            
        """.trimMargin()
    return createFlow(__db, false, arrayOf("vodTable", "watchedVodStreamsTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (limit == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, limit.toLong())
        }
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "watched_streamId")
        val _columnIndexOfAdded: Int = getColumnIndexOrThrow(_stmt, "watched_added")
        val _columnIndexOfProgress: Int = getColumnIndexOrThrow(_stmt, "watched_progress")
        val _columnIndexOfTotalProgress: Int = getColumnIndexOrThrow(_stmt, "watched_totalProgress")
        val _columnIndexOfBackdrop: Int = getColumnIndexOrThrow(_stmt, "watched_backdrop")
        val _columnIndexOfAdded_1: Int = getColumnIndexOrThrow(_stmt, "added")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfCustomSid: Int = getColumnIndexOrThrow(_stmt, "customSid")
        val _columnIndexOfDirectSource: Int = getColumnIndexOrThrow(_stmt, "directSource")
        val _columnIndexOfIsAdult: Int = getColumnIndexOrThrow(_stmt, "isAdult")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfStreamId_1: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _columnIndexOfContainerExtension: Int = getColumnIndexOrThrow(_stmt, "containerExtension")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _result: MutableList<WatchedIntermediateVodStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: WatchedIntermediateVodStream
          val _tmpWatchedBaseStream: WatchedVodStreams
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpProgress: Long?
          if (_stmt.isNull(_columnIndexOfProgress)) {
            _tmpProgress = null
          } else {
            _tmpProgress = _stmt.getLong(_columnIndexOfProgress)
          }
          val _tmpTotalProgress: Long?
          if (_stmt.isNull(_columnIndexOfTotalProgress)) {
            _tmpTotalProgress = null
          } else {
            _tmpTotalProgress = _stmt.getLong(_columnIndexOfTotalProgress)
          }
          val _tmpBackdrop: String?
          if (_stmt.isNull(_columnIndexOfBackdrop)) {
            _tmpBackdrop = null
          } else {
            _tmpBackdrop = _stmt.getText(_columnIndexOfBackdrop)
          }
          _tmpWatchedBaseStream = WatchedVodStreams(_tmpStreamId,_tmpProgress,_tmpTotalProgress,_tmpBackdrop)
          _tmpWatchedBaseStream.added = _stmt.getLong(_columnIndexOfAdded)
          val _tmpBaseStream: VodStream
          val _tmpAdded: String
          _tmpAdded = _stmt.getText(_columnIndexOfAdded_1)
          val _tmpCategoryId: Int
          _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          val _tmpCustomSid: String?
          if (_stmt.isNull(_columnIndexOfCustomSid)) {
            _tmpCustomSid = null
          } else {
            _tmpCustomSid = _stmt.getText(_columnIndexOfCustomSid)
          }
          val _tmpDirectSource: String?
          if (_stmt.isNull(_columnIndexOfDirectSource)) {
            _tmpDirectSource = null
          } else {
            _tmpDirectSource = _stmt.getText(_columnIndexOfDirectSource)
          }
          val _tmpIsAdult: Int
          _tmpIsAdult = _stmt.getLong(_columnIndexOfIsAdult).toInt()
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpStreamId_1: Int
          _tmpStreamId_1 = _stmt.getLong(_columnIndexOfStreamId_1).toInt()
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          val _tmpContainerExtension: String
          _tmpContainerExtension = _stmt.getText(_columnIndexOfContainerExtension)
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          _tmpBaseStream = VodStream(_tmpAdded,_tmpCategoryId,_tmpCustomSid,_tmpDirectSource,_tmpIsAdult,_tmpName,_tmpNum,_tmpStreamIcon,_tmpStreamId_1,_tmpStreamType,_tmpContainerExtension,_tmpRating,_tmpRatingFiveBased)
          _item = WatchedIntermediateVodStream(_tmpBaseStream,_tmpWatchedBaseStream)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun getWatchedStreamsAsIntermediate(limit: Int?): List<WatchedIntermediateVodStream> {
    val _sql: String = """
        |SELECT 
        |watchedVodStreamsTable.streamId AS watched_streamId, 
        |watchedVodStreamsTable.added AS watched_added, 
        |watchedVodStreamsTable.progress AS watched_progress, 
        |watchedVodStreamsTable.totalProgress AS watched_totalProgress, 
        |watchedVodStreamsTable.backdrop AS watched_backdrop, 
        |        vodTable.*
        |         FROM vodTable
        |            INNER JOIN watchedVodStreamsTable 
        |            ON vodTable.streamId = watchedVodStreamsTable.streamId
        |            ORDER BY watchedVodStreamsTable.added DESC LIMIT ?            
        |            
        """.trimMargin()
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (limit == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, limit.toLong())
        }
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "watched_streamId")
        val _columnIndexOfAdded: Int = getColumnIndexOrThrow(_stmt, "watched_added")
        val _columnIndexOfProgress: Int = getColumnIndexOrThrow(_stmt, "watched_progress")
        val _columnIndexOfTotalProgress: Int = getColumnIndexOrThrow(_stmt, "watched_totalProgress")
        val _columnIndexOfBackdrop: Int = getColumnIndexOrThrow(_stmt, "watched_backdrop")
        val _columnIndexOfAdded_1: Int = getColumnIndexOrThrow(_stmt, "added")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfCustomSid: Int = getColumnIndexOrThrow(_stmt, "customSid")
        val _columnIndexOfDirectSource: Int = getColumnIndexOrThrow(_stmt, "directSource")
        val _columnIndexOfIsAdult: Int = getColumnIndexOrThrow(_stmt, "isAdult")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfStreamId_1: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _columnIndexOfContainerExtension: Int = getColumnIndexOrThrow(_stmt, "containerExtension")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _result: MutableList<WatchedIntermediateVodStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: WatchedIntermediateVodStream
          val _tmpWatchedBaseStream: WatchedVodStreams
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpProgress: Long?
          if (_stmt.isNull(_columnIndexOfProgress)) {
            _tmpProgress = null
          } else {
            _tmpProgress = _stmt.getLong(_columnIndexOfProgress)
          }
          val _tmpTotalProgress: Long?
          if (_stmt.isNull(_columnIndexOfTotalProgress)) {
            _tmpTotalProgress = null
          } else {
            _tmpTotalProgress = _stmt.getLong(_columnIndexOfTotalProgress)
          }
          val _tmpBackdrop: String?
          if (_stmt.isNull(_columnIndexOfBackdrop)) {
            _tmpBackdrop = null
          } else {
            _tmpBackdrop = _stmt.getText(_columnIndexOfBackdrop)
          }
          _tmpWatchedBaseStream = WatchedVodStreams(_tmpStreamId,_tmpProgress,_tmpTotalProgress,_tmpBackdrop)
          _tmpWatchedBaseStream.added = _stmt.getLong(_columnIndexOfAdded)
          val _tmpBaseStream: VodStream
          val _tmpAdded: String
          _tmpAdded = _stmt.getText(_columnIndexOfAdded_1)
          val _tmpCategoryId: Int
          _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          val _tmpCustomSid: String?
          if (_stmt.isNull(_columnIndexOfCustomSid)) {
            _tmpCustomSid = null
          } else {
            _tmpCustomSid = _stmt.getText(_columnIndexOfCustomSid)
          }
          val _tmpDirectSource: String?
          if (_stmt.isNull(_columnIndexOfDirectSource)) {
            _tmpDirectSource = null
          } else {
            _tmpDirectSource = _stmt.getText(_columnIndexOfDirectSource)
          }
          val _tmpIsAdult: Int
          _tmpIsAdult = _stmt.getLong(_columnIndexOfIsAdult).toInt()
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpStreamId_1: Int
          _tmpStreamId_1 = _stmt.getLong(_columnIndexOfStreamId_1).toInt()
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          val _tmpContainerExtension: String
          _tmpContainerExtension = _stmt.getText(_columnIndexOfContainerExtension)
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          _tmpBaseStream = VodStream(_tmpAdded,_tmpCategoryId,_tmpCustomSid,_tmpDirectSource,_tmpIsAdult,_tmpName,_tmpNum,_tmpStreamIcon,_tmpStreamId_1,_tmpStreamType,_tmpContainerExtension,_tmpRating,_tmpRatingFiveBased)
          _item = WatchedIntermediateVodStream(_tmpBaseStream,_tmpWatchedBaseStream)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun topAsFlow(limit: Int): Flow<List<VodStream>> {
    val _sql: String = """
        |
        |        SELECT * FROM vodTable
        |        ORDER BY rating DESC
        |        LIMIT ?
        |        
        """.trimMargin()
    return createFlow(__db, false, arrayOf("vodTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindLong(_argIndex, limit.toLong())
        val _columnIndexOfAdded: Int = getColumnIndexOrThrow(_stmt, "added")
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfCustomSid: Int = getColumnIndexOrThrow(_stmt, "customSid")
        val _columnIndexOfDirectSource: Int = getColumnIndexOrThrow(_stmt, "directSource")
        val _columnIndexOfIsAdult: Int = getColumnIndexOrThrow(_stmt, "isAdult")
        val _columnIndexOfName: Int = getColumnIndexOrThrow(_stmt, "name")
        val _columnIndexOfNum: Int = getColumnIndexOrThrow(_stmt, "num")
        val _columnIndexOfStreamIcon: Int = getColumnIndexOrThrow(_stmt, "streamIcon")
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfStreamType: Int = getColumnIndexOrThrow(_stmt, "streamType")
        val _columnIndexOfContainerExtension: Int = getColumnIndexOrThrow(_stmt, "containerExtension")
        val _columnIndexOfRating: Int = getColumnIndexOrThrow(_stmt, "rating")
        val _columnIndexOfRatingFiveBased: Int = getColumnIndexOrThrow(_stmt, "ratingFiveBased")
        val _result: MutableList<VodStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: VodStream
          val _tmpAdded: String
          _tmpAdded = _stmt.getText(_columnIndexOfAdded)
          val _tmpCategoryId: Int
          _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          val _tmpCustomSid: String?
          if (_stmt.isNull(_columnIndexOfCustomSid)) {
            _tmpCustomSid = null
          } else {
            _tmpCustomSid = _stmt.getText(_columnIndexOfCustomSid)
          }
          val _tmpDirectSource: String?
          if (_stmt.isNull(_columnIndexOfDirectSource)) {
            _tmpDirectSource = null
          } else {
            _tmpDirectSource = _stmt.getText(_columnIndexOfDirectSource)
          }
          val _tmpIsAdult: Int
          _tmpIsAdult = _stmt.getLong(_columnIndexOfIsAdult).toInt()
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpNum: Int?
          if (_stmt.isNull(_columnIndexOfNum)) {
            _tmpNum = null
          } else {
            _tmpNum = _stmt.getLong(_columnIndexOfNum).toInt()
          }
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpStreamType: String
          _tmpStreamType = _stmt.getText(_columnIndexOfStreamType)
          val _tmpContainerExtension: String
          _tmpContainerExtension = _stmt.getText(_columnIndexOfContainerExtension)
          val _tmpRating: String?
          if (_stmt.isNull(_columnIndexOfRating)) {
            _tmpRating = null
          } else {
            _tmpRating = _stmt.getText(_columnIndexOfRating)
          }
          val _tmpRatingFiveBased: String?
          if (_stmt.isNull(_columnIndexOfRatingFiveBased)) {
            _tmpRatingFiveBased = null
          } else {
            _tmpRatingFiveBased = _stmt.getText(_columnIndexOfRatingFiveBased)
          }
          _item = VodStream(_tmpAdded,_tmpCategoryId,_tmpCustomSid,_tmpDirectSource,_tmpIsAdult,_tmpName,_tmpNum,_tmpStreamIcon,_tmpStreamId,_tmpStreamType,_tmpContainerExtension,_tmpRating,_tmpRatingFiveBased)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun trendingAsFlow(): Flow<List<TrendingMovie>> {
    val _sql: String = """
        |
        |SELECT 
        |    trending.streamIcon, 
        |    trending.name, 
        |    trending.adult, 
        |    trending.id, 
        |    trending.overview, 
        |    trending.backdrop,
        |    trending.popularity, 
        |    trending.releaseDate, 
        |    trending.voteAverage,
        |    vod.streamId
        |FROM TrendingMovies trending 
        |JOIN vodTable vod 
        |    ON vod.name LIKE trending.name
        |WHERE vod.streamIcon IS NOT NULL
        |GROUP BY vod.streamId
        |""".trimMargin()
    return createFlow(__db, false, arrayOf("TrendingMovies", "vodTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _columnIndexOfStreamIcon: Int = 0
        val _columnIndexOfName: Int = 1
        val _columnIndexOfAdult: Int = 2
        val _columnIndexOfId: Int = 3
        val _columnIndexOfOverview: Int = 4
        val _columnIndexOfBackdrop: Int = 5
        val _columnIndexOfPopularity: Int = 6
        val _columnIndexOfReleaseDate: Int = 7
        val _columnIndexOfVoteAverage: Int = 8
        val _columnIndexOfStreamId: Int = 9
        val _result: MutableList<TrendingMovie> = mutableListOf()
        while (_stmt.step()) {
          val _item: TrendingMovie
          val _tmpStreamIcon: String?
          if (_stmt.isNull(_columnIndexOfStreamIcon)) {
            _tmpStreamIcon = null
          } else {
            _tmpStreamIcon = _stmt.getText(_columnIndexOfStreamIcon)
          }
          val _tmpName: String
          _tmpName = _stmt.getText(_columnIndexOfName)
          val _tmpAdult: Boolean
          val _tmp: Int
          _tmp = _stmt.getLong(_columnIndexOfAdult).toInt()
          _tmpAdult = _tmp != 0
          val _tmpId: Int
          _tmpId = _stmt.getLong(_columnIndexOfId).toInt()
          val _tmpOverview: String
          _tmpOverview = _stmt.getText(_columnIndexOfOverview)
          val _tmpBackdrop: String?
          if (_stmt.isNull(_columnIndexOfBackdrop)) {
            _tmpBackdrop = null
          } else {
            _tmpBackdrop = _stmt.getText(_columnIndexOfBackdrop)
          }
          val _tmpPopularity: Float?
          if (_stmt.isNull(_columnIndexOfPopularity)) {
            _tmpPopularity = null
          } else {
            _tmpPopularity = _stmt.getDouble(_columnIndexOfPopularity).toFloat()
          }
          val _tmpReleaseDate: String
          _tmpReleaseDate = _stmt.getText(_columnIndexOfReleaseDate)
          val _tmpVoteAverage: Double?
          if (_stmt.isNull(_columnIndexOfVoteAverage)) {
            _tmpVoteAverage = null
          } else {
            _tmpVoteAverage = _stmt.getDouble(_columnIndexOfVoteAverage)
          }
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          _item = TrendingMovie(_tmpAdult,_tmpBackdrop,_tmpId,_tmpName,_tmpOverview,_tmpStreamIcon,_tmpPopularity,_tmpReleaseDate,_tmpVoteAverage,_tmpStreamId)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun deleteAll() {
    val _sql: String = "DELETE FROM vodTable"
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun deleteTrending() {
    val _sql: String = "DELETE FROM TrendingMovies"
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun allAsPagingSourceRaw(query: RoomRawQuery): PagingSource<Int, VodStream> {
    val _sql: String = query.sql
    val _rawQuery: RoomRawQuery = RoomRawQuery(_sql) { _stmt ->
      query.getBindingFunction().invoke(_stmt)
    }
    return __pagingSourceDaoReturnTypeConverter.convert(__db, arrayOf("vodTable"), _rawQuery) { _converterQuery ->
      performSuspending<MutableList<VodStream>>(__db, true, false) { _connection ->
        val _stmt: SQLiteStatement = _connection.prepare(_converterQuery.sql)
        try {
          _converterQuery.getBindingFunction().invoke(_stmt)
          val _result: MutableList<VodStream> = mutableListOf()
          while (_stmt.step()) {
            val _item: VodStream
            _item = __entityStatementConverter_comXtreamDataKmpDtoVodStream(_stmt)
            _result.add(_item)
          }
          _result
        } finally {
          _stmt.close()
        }
      }
    }
  }

  public override suspend fun getVodByIcons(query: RoomRawQuery): List<VodStream> {
    val _sql: String = query.sql
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        query.getBindingFunction().invoke(_stmt)
        val _result: MutableList<VodStream> = mutableListOf()
        while (_stmt.step()) {
          val _item: VodStream
          _item = __entityStatementConverter_comXtreamDataKmpDtoVodStream(_stmt)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  private fun __entityStatementConverter_comXtreamDataKmpDtoVodStream(statement: SQLiteStatement): VodStream {
    val _entity: VodStream
    val _columnIndexOfAdded: Int = getColumnIndex(statement, "added")
    val _columnIndexOfCategoryId: Int = getColumnIndex(statement, "categoryId")
    val _columnIndexOfCustomSid: Int = getColumnIndex(statement, "customSid")
    val _columnIndexOfDirectSource: Int = getColumnIndex(statement, "directSource")
    val _columnIndexOfIsAdult: Int = getColumnIndex(statement, "isAdult")
    val _columnIndexOfName: Int = getColumnIndex(statement, "name")
    val _columnIndexOfNum: Int = getColumnIndex(statement, "num")
    val _columnIndexOfStreamIcon: Int = getColumnIndex(statement, "streamIcon")
    val _columnIndexOfStreamId: Int = getColumnIndex(statement, "streamId")
    val _columnIndexOfStreamType: Int = getColumnIndex(statement, "streamType")
    val _columnIndexOfContainerExtension: Int = getColumnIndex(statement, "containerExtension")
    val _columnIndexOfRating: Int = getColumnIndex(statement, "rating")
    val _columnIndexOfRatingFiveBased: Int = getColumnIndex(statement, "ratingFiveBased")
    val _tmpAdded: String
    if (_columnIndexOfAdded == -1) {
      error("Missing column 'added' for a NON-NULL value, column not found in result.")
    } else {
      _tmpAdded = statement.getText(_columnIndexOfAdded)
    }
    val _tmpCategoryId: Int
    if (_columnIndexOfCategoryId == -1) {
      _tmpCategoryId = 0
    } else {
      _tmpCategoryId = statement.getLong(_columnIndexOfCategoryId).toInt()
    }
    val _tmpCustomSid: String?
    if (_columnIndexOfCustomSid == -1) {
      _tmpCustomSid = null
    } else {
      if (statement.isNull(_columnIndexOfCustomSid)) {
        _tmpCustomSid = null
      } else {
        _tmpCustomSid = statement.getText(_columnIndexOfCustomSid)
      }
    }
    val _tmpDirectSource: String?
    if (_columnIndexOfDirectSource == -1) {
      _tmpDirectSource = null
    } else {
      if (statement.isNull(_columnIndexOfDirectSource)) {
        _tmpDirectSource = null
      } else {
        _tmpDirectSource = statement.getText(_columnIndexOfDirectSource)
      }
    }
    val _tmpIsAdult: Int
    if (_columnIndexOfIsAdult == -1) {
      _tmpIsAdult = 0
    } else {
      _tmpIsAdult = statement.getLong(_columnIndexOfIsAdult).toInt()
    }
    val _tmpName: String
    if (_columnIndexOfName == -1) {
      error("Missing column 'name' for a NON-NULL value, column not found in result.")
    } else {
      _tmpName = statement.getText(_columnIndexOfName)
    }
    val _tmpNum: Int?
    if (_columnIndexOfNum == -1) {
      _tmpNum = null
    } else {
      if (statement.isNull(_columnIndexOfNum)) {
        _tmpNum = null
      } else {
        _tmpNum = statement.getLong(_columnIndexOfNum).toInt()
      }
    }
    val _tmpStreamIcon: String?
    if (_columnIndexOfStreamIcon == -1) {
      _tmpStreamIcon = null
    } else {
      if (statement.isNull(_columnIndexOfStreamIcon)) {
        _tmpStreamIcon = null
      } else {
        _tmpStreamIcon = statement.getText(_columnIndexOfStreamIcon)
      }
    }
    val _tmpStreamId: Int
    if (_columnIndexOfStreamId == -1) {
      _tmpStreamId = 0
    } else {
      _tmpStreamId = statement.getLong(_columnIndexOfStreamId).toInt()
    }
    val _tmpStreamType: String
    if (_columnIndexOfStreamType == -1) {
      error("Missing column 'streamType' for a NON-NULL value, column not found in result.")
    } else {
      _tmpStreamType = statement.getText(_columnIndexOfStreamType)
    }
    val _tmpContainerExtension: String
    if (_columnIndexOfContainerExtension == -1) {
      error("Missing column 'containerExtension' for a NON-NULL value, column not found in result.")
    } else {
      _tmpContainerExtension = statement.getText(_columnIndexOfContainerExtension)
    }
    val _tmpRating: String?
    if (_columnIndexOfRating == -1) {
      _tmpRating = null
    } else {
      if (statement.isNull(_columnIndexOfRating)) {
        _tmpRating = null
      } else {
        _tmpRating = statement.getText(_columnIndexOfRating)
      }
    }
    val _tmpRatingFiveBased: String?
    if (_columnIndexOfRatingFiveBased == -1) {
      _tmpRatingFiveBased = null
    } else {
      if (statement.isNull(_columnIndexOfRatingFiveBased)) {
        _tmpRatingFiveBased = null
      } else {
        _tmpRatingFiveBased = statement.getText(_columnIndexOfRatingFiveBased)
      }
    }
    _entity = VodStream(_tmpAdded,_tmpCategoryId,_tmpCustomSid,_tmpDirectSource,_tmpIsAdult,_tmpName,_tmpNum,_tmpStreamIcon,_tmpStreamId,_tmpStreamType,_tmpContainerExtension,_tmpRating,_tmpRatingFiveBased)
    return _entity
  }

  public companion object {
    public fun getRequiredColumnConverters(): List<KClass<*>> = emptyList()

    public fun getRequiredDaoReturnTypeConverters(): List<KClass<*>> = emptyList()
  }
}
